import ApiService from '../api.services';

const PackageTableService = {
    list: async function () {
        try {
            const response = await ApiService.get('/api/packagetable');
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    get: async function (id) {
        try {
            const response = await ApiService.get(`/api/packagetable/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    add: async function (data) {
        try {
            const response = await ApiService.post('/api/packagetable', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    update: async function (id, data) {
        try {
            const response = await ApiService.put(`/api/packagetable/${id}`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    delete: async function (id) {
        try {
            const response = await ApiService.delete(`/api/packagetable/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
};

export default PackageTableService;

export { PackageTableService };

